import React from 'react';
import styles from '../styles/PageHero.module.css';

interface PageHeroProps {
    backgroundImage: string;
    title: string;
    subtitle: string;
    description: string;
    breadcrumb?: {
        home: string;
        current: string;
    };
}

const PageHero: React.FC<PageHeroProps> = ({ 
    backgroundImage, 
    title,
    subtitle,
    description,
    breadcrumb 
}) => {
    return (
        <div 
            className={styles.pageHero} 
            style={{ 
                backgroundImage: `url(${backgroundImage})` 
            }}
        >
            <div className={styles.heroContent}>
                <div className={styles.pageHeroTitle}>
                    <h1>{title}</h1>
                    <h2 className="subtitle">{subtitle}</h2>
                </div>
                <div className={styles.heroDescription}>
                    <p>{description}</p>
                </div>
                {breadcrumb && (
                    <div className={styles.breadcrumb}>
                        <span className="home">{breadcrumb.home}</span>
                        <span className="separator">|</span>
                        <span className="current">{breadcrumb.current}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PageHero; 